import { observer } from 'mobx-react';
import React from 'react';
import { makeAutoObservable } from 'mobx';
import { IUserConfigPackage } from '../../../API';
import SearchCtrl, { SearchCtrlStyle } from '../SearchCtrl';

export interface IDocumentSearchBarProps {
	state: DocumentSearchBarState;
}

class DocumentSearchBar extends React.Component<IDocumentSearchBarProps, {}> {
	render() {
		return (
			<SearchCtrl
				style={SearchCtrlStyle.Standard}
				placeholder={this.props.state.caption}
				onSearchTextChanged={(searchText: string) => {
					this.props.state.onSearch(searchText);
				}}
			/>
		);
	}
}

export class DocumentSearchBarState {
	public userConfig: IUserConfigPackage;
	public onSearch: (searchText: string) => void;

	constructor(
		userConfig: IUserConfigPackage,
		onSearch: (searchText: string) => void,
	) {
		makeAutoObservable(this);
		this.userConfig = userConfig;
		this.onSearch = onSearch;
	}

	public caption: string = 'Search...';
	public setCaption(caption: string) {
		this.caption = caption;
	}
}

export default observer(DocumentSearchBar);
